/* @flow */
import React from 'react';

import Table from 'components/UIKit/Table';
import AnnotationsColumns from './AnnotationsColumns';
import AnnotationsRows from './AnnotationsRows';

type AnnotationsTableProps = {
  router: Object,
  sort: string,
  order: string,
  children: any
}

export default function AnnotationsTable({
  children, router, sort, order
}: AnnotationsTableProps): React.Element {
  return (
    <Table>
      <AnnotationsColumns sort={sort} order={order} />
      <AnnotationsRows router={router}>
        {children}
      </AnnotationsRows>
    </Table>
  );
}
